import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ButtonComponent } from './components/common/button/button.component';
import { HeaderComponent } from './components/header/header.component';
import { InputComponent } from './components/common/input/input.component';
import { FooterComponent } from './components/footer/footer.component';
import { PageComponent } from './components/common/page/page.component';
import { SearchPageComponent } from './views/search-page/search-page.component';
import { SearchResultsComponent } from './views/search-results/search-results.component';
import { FormsModule } from '@angular/forms';
import { SearchResultComponent } from './views/search-results/search-result/search-result.component';

@NgModule({ declarations: [
        AppComponent,
        ButtonComponent,
        HeaderComponent,
        FooterComponent,
        InputComponent,
        PageComponent,
        SearchPageComponent,
        SearchResultsComponent,
        SearchResultComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule, AppRoutingModule, FormsModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
